if (window.jQuery) {

  $(function() {

    if ( $( '.header__logo-image-boutique' ).length ) {

      var header = $('.header--with-horizontal-nav');
      var pageContent = $('#shopify-section-collection-template');
      var footer = $('.footer');

      header.addClass('header-boutique');
      pageContent.addClass('section-boutique');
      footer.addClass('footer-boutique');
    }

    $('.productInfoModal').dialog({
      autoOpen: false,
      width: 500,
      maxWidth: 500,
      height: 'auto',
      maxHeight: 600,
      modal: true,
      fluid: true,
      resizable: false,
      show: {
        effect: "fadeIn",
        duration: 100
      },
      hide: {
        effect: "fadeOut",
        duration: 100
      }
    });

    $('.product-info-icon, .product-info-link').on( "click", function() {
      //takes the ID of appropriate dialogue
      var productInfoModalId = $(this).data('id');
      //open dialogue
      $(productInfoModalId).dialog("open");
    });

    $('.info-icon').on( "click", function() {
      //takes the ID of appropriate dialogue
      var infoModalId = $(this).data('id');
      //open dialogue
      $(infoModalId).dialog("open");
    });

    $('.donation-value .info-icon').on( "click", function() {
      //takes the ID of appropriate dialogue
      var infoModalId = $(this).data('id');
      //open dialogue
      // $(infoModalId).dialog("open");
      $('.ui-dialog').addClass("donation-dialog");

      $(infoModalId).dialog("option", "position", {
        my: "left bottom",
        at: "left top-40",
        of: $(this).closest($('.donation-value')) // this refers to the cliked element
      }).dialog("open");

      if ($(window).width() <= 480) {
        $(infoModalId).dialog("option", "position", {
          my: "center",
          at: "center",
          of: window
        }).dialog("open");
      }
    });

    // on window resize run function
    $(window).resize(function () {
      fluidDialog();
    });

    // catch dialog if opened within a viewport smaller than the dialog width
    $(document).on("dialogopen", ".ui-dialog", function (event, ui) {
      fluidDialog();
    });

    function fluidDialog() {
      var $visible = $(".ui-dialog:visible");
      // each open dialog
      $visible.each(function () {
        var $this = $(this);
        var dialog = $this.find(".ui-dialog-content").data("ui-dialog");
        // if fluid option == true
        if (dialog.options.fluid) {
          var wWidth = $(window).width();
          // check window width against dialog width
          if (wWidth < (parseInt(dialog.options.maxWidth) + 50))  {
            // keep dialog from filling entire screen
            $this.css("max-width", "90%");
          } else {
            // fix maxWidth bug
            $this.css("max-width", dialog.options.maxWidth + "px");
          }
          //reposition dialog
          dialog.option("position", dialog.options.position);
        }
      });

    }

    /**
    * -------------------------
    * Replace all SVG images with inline SVG
    * -------------------------
    */

    jQuery('img.svg').each(function(){
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      jQuery.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if(typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if(typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass+' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Replace image with new SVG
        $img.replaceWith($svg);

      }, 'xml');

    });

    /**
    * -------------------------
    * Product slideshow
    * -------------------------
    */
    var initProductSlideshow = function(productSlideshow) {
      $('.product__thumbnail:first-child').addClass('thumbnail-border');

      productSlideshow.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.product__thumbnail').removeClass('thumbnail-border');
        $('.product__thumbnail:first-child').removeClass('thumbnail-border');
        var mySlideNumber = nextSlide;
        $(".product__thumbnails .product__thumbnail:eq("+mySlideNumber+")").addClass('thumbnail-border');
      });

      // Thumbnails

      productSlideshow.next('.product__thumbnails').find('.product__thumbnail').on('click', function() {
        $('.product__thumbnail').removeClass('thumbnail-border');
        productSlideshow.slick('slickGoTo', $(this).attr('data-index'),
        $(this).addClass('thumbnail-border'));
        return false;
      });
    };

    initProductSlideshow($('.product__slideshow'));

    $(document).on('shopify:section:unload', function(event) {
      var target = $(event.target);

      target.find('.product__slideshow').slick('unslick');
      target.find('.product__slideshow-nav-image').off('click');
      $(document).off('.product__slideshow');
    });

    $(document).on('shopify:section:load', function(event) {
      initProductSlideshow($(event.target).find('.product__slideshow'));
    });

    if ( $( ".header__item-search" ).hasClass ("header__item-search--expanded") ) {
      $( ".header__item-search-text" ).hide();
    }

    ssm.addState({
      id: 'tablet',
      query: '(min-width: 768px)',
      onEnter: function(){
        // console.log('enter tablet');
        if ($("#bc-sf-filter-tree").length > 0) {

          var LHSFilterOffset = $("#bc-sf-filter-tree").offset().top;
          var eTop = $("#bc-sf-filter-products").offset().top;

          $(document).scroll(function() {

            var scrollPos = $(document).scrollTop();
            var eHeight = $("#bc-sf-filter-products").height();
            var eBottom = eTop + eHeight - $(window).height();

            // console.log('scrollPos: '+ scrollPos);
            // console.log('eHeight:' + eHeight);

            $("#bc-sf-filter-tree").removeClass("stuckFilter");

            if (scrollPos >= LHSFilterOffset && scrollPos <= eBottom) {
              $("#bc-sf-filter-tree").addClass("stuckFilter");
            } else {
              $("#bc-sf-filter-tree").removeClass("stuckFilter");
            }
          });
        }
      }
    });

    ssm.addState({
      id: 'mobile',
      query: '(max-width: 767px)',
      onEnter: function(){
        $('#navigation-horizontal-sell .navigation-horizontal__list-item--expandable > .navigation-horizontal__list-link').on('click', function() {
          var element = $(this),
          item = element.closest('.navigation-horizontal__list-item');

          item.toggleClass('navigation-horizontal__list-item--active').attr('aria-expanded', function(index, attr) {return attr === 'true' ? 'false' : 'true'});
          item.siblings().removeClass('navigation-horizontal__list-item--active').attr('aria-expanded', 'false')
          .find('.navigation-horizontal__dropdown-item--active').removeClass('navigation-horizontal__dropdown-item--active').attr('aria-expanded', 'false');


          $(document).on('click', function(e) {
            if ($(e.target).closest('.navigation-horizontal').length === 0) {
              item.removeClass('navigation-horizontal__list-item--active').attr('aria-expanded', 'false');
              item.find('.navigation-horizontal__dropdown-item--active').removeClass('navigation-horizontal__dropdown-item--active').attr('aria-expanded', 'false');

              $(document).off('click');
            }
          });

          return false;
        });
        $('.product_functions-button').text('Improve');
      }
    });

  })

  $(function() {

    $('.customer-account-pages button[type="submit"]').prop('disabled', true);
    $('.customer-account-pages input').keyup(function() {
      if($(this).val() != '') {
        $('.customer-account-pages button[type="submit"]').prop('disabled', false);
      }
    });

  })

}
